<footer class="footer">
    <div class="container">

        <p class="text-muted text-center" style="font-size: 15px; color: #0088f2;">

        </p>
        <p class="text-muted text-center" style="font-size: 13px; margin-bottom: 10px !important;">
            <button *ngIf="!isAuthenticated"  ghost nbButton  (click)="goPage()" >Correspondent Sign-in</button><button *ngIf="isAuthenticated"  ghost nbButton  (click)="goPage()" >Dashboard</button>|<button *ngIf="isAuthenticated"  ghost nbButton  (click)="logout()">Log-out</button>
        </p>

    </div>
</footer>
